<template>
  <z-container>
    <!-- <h3>Balanço</h3> -->

    <v-expand-transition>

      <v-card class="mb-3" v-show="iniciou && !terminou">
        <v-card-text>
          <v-row dense>
            <v-col cols="8">
              <v-card color="primary" dark flat>
                <v-card-text class="pa-3" style="min-height: 114px">
                  <div>Produto</div>
                  <h4 class="headline white--text">
                    {{ produto.descricao }}
                  </h4>

                  <div class="d-flex mt-3" style="gap: 2px;" v-if="produto.grade">
                    <v-chip
                      v-for="(grade, index) in produto.grade"
                      small
                      color="white"
                      class="teal--text"
                      :key="index"
                      @click="$refs.dialogoSelecionarVariacao.abrir()"
                    >{{ grade.descricao }}</v-chip>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="4">
              <v-card color="primary" dark flat>
                <v-card-text class="pa-3" style="min-height: 114px">
                  <div>Estoque Atual</div>
                  <h4 class="headline white--text">
                    {{ produto.estoque }} {{ produto.unidade }}
                  </h4>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row dense class="mt-4">
            <v-col cols="3" sm="3">
              <v-text-field
                v-model="busca.referencia"
                dense
                filled
                append-icon="search"
                ref="referencia"
                label="Referência"
                placeholder=" "
                autofocus
                hide-details
                :loading="buscando"
                @keyup.enter="buscarReferencia"
                @keyup.esc="cancelar"
                @click:append="buscarProduto"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <z-campo-valor
                v-model="busca.estoque"
                dense
                ref="estoque"
                label="Quatidade"
                hide-details
                filled
                :decimais="0"
                :disabled="busca.descricao == ''"
                @keyup.esc="cancelar"
                @keyup.enter="adicionarItem"
              >
                <template #append>
                  <v-btn 
                    class="ml-3" 
                    color="primary"
                    small 
                    depressed
                    :disabled="busca.descricao == ''"
                    @click="adicionarItem"
                  >
                    Enter
                  </v-btn>
                </template>
              </z-campo-valor>
            </v-col>
            <v-col align-self="end">
              
              <!-- <v-btn
                color="primary"
                class="mr-4"
                depressed
                :disabled="busca.descricao == ''"
                @click="cancelar"
              >Cancelar</v-btn> -->
              <!-- <v-btn
                color="primary"
                depressed
                :disabled="busca.descricao == ''"
                @click="adicionarItem"
              >Confirmar</v-btn> -->
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" class="pt-0">
            
              Pressione <code>ENTER</code> para confirmar ou <code>ESC</code> para cancelar.
            
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      
    </v-expand-transition>

      <!-- <adicionar-produto 
        class="mb-3 sticky" 
        ref="adicionarProduto"
        movimento-estoque
      ></adicionar-produto> -->
      
    <v-row dense>
      <v-col cols="12">

        <v-card>
          <v-card-actions>
            <v-btn
              color="primary"
              depressed
              rounded
              :disabled="terminando"
              @click="$refs.dialogoBalancos.abrir()"
            >Selecionar Balanço</v-btn>

            <v-btn
              depressed
              rounded
              :disabled="terminando || itens.length == 0"
              @click="imprimir"
            >
              <v-icon left>mdi-printer</v-icon>
              Imprimir
            </v-btn>

            <v-btn
              icon
              :loading="carregando_itens"
              @click="init"
            >
              <v-icon left>mdi-refresh</v-icon>
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              depressed
              rounded
              :disabled="iniciou || !balanco.descricao"
              @click="iniciarBalanco"
            >Iniciar</v-btn>

            <v-btn
              color="primary"
              depressed
              rounded
              :loading="terminando"
              :disabled="!iniciou || terminou"
              @click="terminarBalanco"
            >Finalizar</v-btn>
          </v-card-actions>

          <v-divider></v-divider>

          <v-toolbar  flat  dense>
            <v-toolbar-title>Itens do Balanço: <b>{{ balanco.descricao }}</b></v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-divider></v-divider>

          <!-- <v-card-title>Balanço: {{ balanco.descricao }}</v-card-title> -->
          <v-card-subtitle>
            <span v-if="!iniciou" class="red--text text-uppercase">Balanço não iniciado</span>
            <span v-else>

              <v-chip class="mr-2" color="primary" label  outlined dark>
                <span class="font-weight-bold mr-3">Início:</span>  
                {{ balanco.data_inicio | dataHoraBR }}
              </v-chip>
              <v-chip label :color="terminou ? 'green' : 'blue'" outlined dark>
                <span class="font-weight-bold mr-3">Finalizado:</span>
                <span v-if="!terminou">Em andamento</span>
                <span v-else>{{ balanco.data_termino | dataHoraBR }}</span>
              </v-chip>

            </span>
          </v-card-subtitle>

          <v-divider></v-divider>

          <v-card-text class="pa-0">

            <v-data-table
              disable-pagination
              disable-sort
              hide-default-footer
              :headers="headers"
              :items="itens"
              :loading="carregando_itens"
            >
              <template v-slot:item="{ item, index }">
                <tr>
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.referencia }}</td>
                  <td>
                    <div>{{ item.descricao }}</div>
                    <template v-if="item.grade">
                      <v-chip
                        v-for="(_grade, index) in item.grade"
                        class="mr-2"
                        x-small 
                        color="grey lighten-2"
                        :key="index"
                      >{{_grade.descricao}}</v-chip>
                    </template>
                  </td>
                  <td class="text-right">
                    <z-campo-valor
                      v-model="item.estoque"
                      dense
                      outlined
                      hide-details
                      single-line
                      decimais="0"
                      style="width: 150px"
                      :disabled="terminou"
                      :loading="item.loading"
                      @change="atualizarItem(item)"
                    ></z-campo-valor>
                  </td>
                  <!-- <td class="text-right">{{ item.valor_custo | valorBR(2) }}</td>
                  <td class="text-right">{{ item.valor_venda | valorBR(2) }}</td> -->
                  <td class="text-center text-no-wrap">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" icon class="ma-0" @click.stop="imprimirEtiqueta(item)" tabindex="-1">
                          <v-icon> mdi-tag </v-icon>
                        </v-btn>
                      </template>
                      Imprimir Etiqueta
                    </v-tooltip>
                    <v-icon v-if="!terminou" @click="removerItem(item)" tabindex="-1">mdi-delete</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>

          </v-card-text>

        </v-card>
      </v-col>
    </v-row>

    <dialogo-balancos
      ref="dialogoBalancos"
      @selecionar="selecionarBalanco"
    ></dialogo-balancos>

    <dialogo-buscar-produto-grupos
      ref="buscaproduto"
      @selecionar:produto="selecionarProduto"
    ></dialogo-buscar-produto-grupos>

    <z-dialogo-sim-nao
      largura="600px"
      ref="dialogoFinalizarBalanco"
      titulo="Finalizar o Balanço?"
      botaoSim="Finalizar"
      botaoNao="Cancelar"
      :loading="terminando"
    >
      Ao clicar em FINALIZAR, o balanço será finalizado e o estoque dos produtos será atualizado para as quantidades abaixo.<br>
      Os produtos que não estiverem nessa lista terão seus estoques zerados.<br>
      Deseja finalizar o balanço atual?
    </z-dialogo-sim-nao>

    <z-dialogo-sim-nao
      ref="dialogoRemoverItem"
      titulo="Remover Item?"
      botaoSim="Remover"
      botaoNao="Não"
    >
      Este item será removido do balanço. Deseja remover?
    </z-dialogo-sim-nao>

    <modelo-etiqueta
      ref="dialogoModeloEtiqueta"
    ></modelo-etiqueta>

    <selecionar-variacao 
      ref="dialogoSelecionarVariacao" 
      :produto="produto"
      @cancelar="onKeyUpEscAdicionarProduto"
      @selecionar:variacao="selecionarVariacao"
    ></selecionar-variacao>

  </z-container>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import config from "@/app/config";

import balancoApi from "@/app/services/balanco";
import produtosApi from "@/app/services/produtos";

import { createLocalStorage } from "@/app/utils/LocalStorage";

import DialogoBalancos from "./DialogoBalancos";
import DialogoBuscarProdutoGrupos from "@/components/buscas/DialogoBuscarProdutoGrupos";

import ModeloEtiqueta from "@/pages/produtos/etiquetas/ModeloEtiqueta.vue";

import AdicionarProduto from "@/pages/produtos/AdicionarProduto";

import SelecionarVariacao from "@/pages/pedidos/SelecionarVariacao";



const storage = createLocalStorage(config);

export default {
  name: "BalancoLista",
  
  components: {
    DialogoBalancos,
    DialogoBuscarProdutoGrupos,
    ModeloEtiqueta,
    AdicionarProduto,
    SelecionarVariacao
  },

  inject: ['$imprimir'],

  data() {
    return {
      busca: {
        referencia: "",
        estoque: 0,
        descricao: "",
      },
      buscando: false,
      terminando: false,
      headers: [
        { text: "Item", value: "", width: "100px" },
        { text: "Referência", value: "referencia", width: "100px" },
        { text: "Descrição", value: "descricao" },
        { text: "Novo Estoque", value: "estoque", width: "100px" },
        // { text: "Valor Custo", value: "valor_custo", align: "right" },
        // { text: "Valor Venda", value: "valor_venda", align: "right" },
        { text: "", value: "", align: "center", width: "100px" },
      ],
      itens: [],
      carregando_itens: false,
      balanco_selecionado: 1,
      balanco: {
        descricao: "",
        data_inicio: "",
        data_termino: "",
      },
      produto: {
        descricao: '',
        unidade: ''
      },
    };
  },

  computed: {
    // ...mapState([
    //   'nameOfState',
    // ])

    iniciou() {
      return !!this.balanco.data_inicio;
    },

    terminou() {
      return !!this.balanco.data_termino;
    },
  },

  mounted() {
    this.init();
  },

  methods: {
    ...mapMutations(["setTitulo"]),
    ...mapActions("produtos", ["buscarProdutoPorReferencia"]),

    async init() {
      if (storage.has("balanco_id")) {
        try {
          this.carregando_itens = true;
          this.balanco_selecionado = storage.get("balanco_id");
          this.balanco = await balancoApi.abrir(this.balanco_selecionado);
          this.itens = this.balanco.itens;
        } catch (error) {
          throw error;
        } finally {
          this.carregando_itens = false;
        }
      }
      this.setTitulo("Balanço Produtos");
    },

    async buscarReferencia() {
      this.limparForm();

      if (!this.busca.referencia) {
        this.buscarProduto();
        return;
      }

      try {
        this.buscando = true;

        let produto = await this.buscarProdutoPorReferencia(
          this.busca.referencia
        );

        // if (produto.lotes > 1) {
        //   this.$refs.buscaproduto.busca = this.busca.referencia;
        //   this.$refs.buscaproduto.buscar();
        //   this.$refs.buscaproduto.abrir();
        // } else {
        this.selecionarProduto(produto);
        // }

        this.$refs.estoque.focus();
      } catch (error) {
        this.$eventbus.erro("Produto não encontrado", error);
        this.busca.descricao = error.response.data.message;
        this.produto = {};
      } finally {
        this.buscando = false;
      }
    },

    buscarProduto() {
      this.$refs.buscaproduto.abrir();
    },

    selecionarProduto(produto) {
      try {
        console.log(produto);
        this.busca.referencia = produto.referencia;
        this.busca.descricao = produto.descricao;
        this.busca.estoque = 1;
  
        this.produto.produto_id = produto.id;
        this.produto.loja_id = produto.loja_id;
        this.produto.lote_id = produto.lote_id;
        this.produto.referencia = produto.referencia;
        this.produto.descricao = produto.descricao;
        this.produto.unidade = produto.unidade;
        this.produto.valor_custo = produto.valor_custo;
        this.produto.valor_venda = produto.valor_venda;
        this.produto.estoque = produto.estoque;
        this.produto.variacoes = produto.variacoes;
  
        if (produto.variacoes.length > 0) {
          this.$refs.dialogoSelecionarVariacao.abrir();
          return;
        }
  
        this.setFocus("estoque");
      } catch (error) {
        console.log(error);
        throw error;
      }
    },

    selecionarVariacao({ grade, quantidade }) {
      this.$set(this.produto, "grade", grade);
      this.produto.estoque = quantidade;
      this.busca.estoque = quantidade;
      // this.produto.subtotal = trunc(Number(this.produto.quantidade) * Number(this.produto.valor));
      // this.setFocus("estoque");
      this.adicionarItem();
    },

    onKeyUpEscAdicionarProduto() {
      this.cancelar();
    },

    validarItem() {
      if (this.busca.referencia == "") {
        return false;
      }

      if (this.busca.descricao == "") {
        return false;
      }

      if (this.busca.estoque == 0) {
        return false;
      }

      if (!this.produto.produto_id) {
        return false;
      }

      return true;
    },

    async adicionarItem() {
      if (!this.validarItem()) {
        this.$eventbus.erroSistema("Dados inválidos.");
        return;
      }

      let produto = {
        balanco_id: this.balanco.id,
        produto_id: this.produto.produto_id,
        referencia: this.produto.referencia,
        descricao: this.produto.descricao,
        estoque: this.busca.estoque,
        grade: this.produto.grade,
      }

      produto = await balancoApi.adicionarItem(produto);

      // this.atualizarLista({...produto});
      this.somarProduto({...produto});

      this.busca.referencia = "";
      this.busca.estoque = 0;
      this.busca.descricao = "";

      this.limparForm();

      this.$refs.referencia.focus();
    },

    async atualizarItem(produto) {

      try {
        this.$set(produto, "loading", true);

        await balancoApi.adicionarItem({
          atualizar: true,
          balanco_id: this.balanco.id,
          produto_id: produto.produto_id,
          descricao: produto.descricao,
          estoque: produto.estoque,
          grade: produto.grade,
        });
        
      } catch (error) {
        this.$eventbus.erro("Não foi possível atualizar o item", error);
      } finally {
        this.$set(produto, "loading", false);
      }
    },

    atualizarLista(produto) {
      let item = this.itens.find((item) => item.produto_id == produto.produto_id);

      if (item) {
        item.estoque += this.busca.estoque;
      } else {
        produto.estoque = this.busca.estoque;
        this.itens.unshift(produto);
      }
    },

    somarProduto(produto) {
      const { index, produto: produto_encontrado } = this.encontrarProdutoNoPedido(produto, this.itens);

      if (index > -1) {
        // const produto_encontrado = this.produtos[index];
        // produto_encontrado.status = produto_encontrado.status != this.$globals.STATUS_PRODUTO.NEW ? this.$globals.STATUS_PRODUTO.CHANGED : produto_encontrado.status;
        produto_encontrado.estoque += Number(this.busca.estoque)
        // produto_encontrado.subtotal = trunc(Number(produto_encontrado.quantidade) * Number(produto_encontrado.valor));
        this.itens.splice(index, 1, produto_encontrado);
      } else {
        this.itens.unshift(produto);
      }
    },

    encontrarProdutoNoPedido(produto, produtos) {
      let index = -1;

      if (!produto.grade) {
        index = produtos.findIndex(_produto => _produto.produto_id == produto.produto_id);
      } else {
        index = this.parseProdutos(produtos).findIndex(_produto => {
          return _produto.grade_descricao == this.parseGradeProduto(produto).grade_descricao;
        });
      }

      return {
        index,
        produto: produtos[index]
      };
    },

    parseProdutos(produtos) {
      let result = [];

      produtos.forEach(item => {
          if ((!!item.grade && item.grade.length === 0) || !item.grade) {
              result.push({
                  id: item.produto_id,
                  referencia: item.referencia,
                  descricao_produto: item.descricao,
                  grade_descricao: null
              });
          } else {
              let grade = '';
              item.grade.forEach(gradeItem => {
                grade += gradeItem.descricao;
              });
              
              result.push({
                  id: item.produto_id,
                  referencia: item.referencia,
                  descricao_produto: item.descricao,
                  grade_descricao: grade
              });
          }
      });

      return result;
    },

    parseGradeProduto(produto) {
      let grade = '';
      produto.grade.forEach(gradeItem => {
        grade += gradeItem.descricao;
      });
      
      return {
          id: produto.produto_id,
          referencia: produto.referencia,
          descricao_produto: produto.descricao,
          grade_descricao: grade
      }
    },

    cancelar() {
      this.busca.referencia = "";
      this.busca.estoque = 0;
      this.busca.descricao = "";
      this.produto = {};
      this.setFocus("referencia");
    },

    async removerItem(produto) {
      const response = await this.$refs.dialogoRemoverItem.abrir();

      if (response == true) {
        this.$refs.dialogoRemoverItem.startLoading();
        await balancoApi.removerItem(produto);

        let index = this.itens.findIndex(
          (item) => item.produto_id == produto.produto_id
        );
        this.itens.splice(index, 1);

        this.$refs.dialogoRemoverItem.fechar();
      }
    },

    async selecionarBalanco(balanco) {
      this.balanco_selecionado = balanco.id;
      storage.set("balanco_id", this.balanco_selecionado);
      this.balanco = balanco;

      try {
        this.itens = [];
        this.carregando_itens = true;
        let { itens } = await balancoApi.abrir(this.balanco_selecionado);
        this.itens = itens;
      } catch (error) {
        this.$eventbus.erro("Não foi possível listar os itens");
      } finally {
        this.carregando_itens = false;
      }
    },

    async iniciarBalanco() {
      this.balanco = await balancoApi.iniciarBalanco(this.balanco_selecionado);
    },

    async terminarBalanco() {
      try {
        const response = await this.$refs.dialogoFinalizarBalanco.abrir();
        if (response == true) {
          this.$refs.dialogoFinalizarBalanco.startLoading()
          this.terminando = true;
          const response = await balancoApi.terminarBalanco(this.balanco_selecionado);
          this.balanco = response.data;
          // await balancoApi.terminarBalanco(this.balanco_selecionado);
          this.$refs.dialogoFinalizarBalanco.fechar();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.terminando = false;
        this.$refs.dialogoFinalizarBalanco.stopLoading();
      }
    },

    imprimir() {
      this.$imprimir(`balanco/${this.balanco.id}/imprimir`);
    },

    async imprimirEtiqueta(item) {
      const { modelo } = await this.$refs.dialogoModeloEtiqueta.abrir();

      if (!modelo) {
        return;
      }

      const produto = {
        id: item.produto_id,
        quantidade: item.estoque,
      };

      await this.$axios.post("/etiquetas/produtos", {
        modelo,
        produtos: [produto],
      });
    },

    limparForm() {
      // this.referencia = null;
      this.produto = {
        referencia: null,
        descricao: null,
        quantidade: 1,
        unidade: "",
        valor: 0,
        subtotal: 0,
        estoque: 0,
        // grade: [],
      };
    },


  },

};
</script>

<style lang="scss" scoped></style>
